module.exports = __webpack_public_path__ + "static/social-banner-80f82f0f6482285f8890456be81f5501.jpg";